const GOOGLE_DAYS = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

function timeInMinutes(time) {
  if (!time) return null;
  return (time.hours ?? 0) * 60 + (time.minutes ?? 0);
}

function nextGoogleDay(day) {
  const index = GOOGLE_DAYS.indexOf(day);
  return index === -1 ? null : GOOGLE_DAYS[(index + 1) % GOOGLE_DAYS.length];
}

/**
 * Google can split one overnight schedule at midnight, for example Friday
 * 22:00-24:00 plus Saturday 00:00-03:00. Join only those touching fragments;
 * periods separated by a gap remain separate and are treated as split hours.
 */
export function normalizeGoogleOpeningPeriods(periods = []) {
  const consumed = new Set();
  const continuations = new Map();

  periods.forEach((period, index) => {
    const followingDay = nextGoogleDay(period.openDay);
    const endsAtMidnight =
      period.closeDay === period.openDay &&
      timeInMinutes(period.closeTime) === 24 * 60;

    if (endsAtMidnight && followingDay) {
      const continuationIndex = periods.findIndex((candidate, candidateIndex) =>
        candidateIndex !== index &&
        !consumed.has(candidateIndex) &&
        candidate.openDay === followingDay &&
        timeInMinutes(candidate.openTime) === 0
      );

      if (continuationIndex !== -1) {
        consumed.add(continuationIndex);
        continuations.set(index, periods[continuationIndex]);
      }
    }
  });

  return periods.flatMap((period, index) => {
    if (consumed.has(index)) return [];
    const continuation = continuations.get(index);
    return [{
      ...period,
      ...(continuation ? {
        closeDay: continuation.closeDay,
        closeTime: continuation.closeTime,
      } : {}),
    }];
  });
}

export function hasSplitGoogleOpeningHours(periods = []) {
  const normalized = normalizeGoogleOpeningPeriods(periods);
  return new Set(normalized.map((period) => period.openDay)).size !== normalized.length;
}
